export default "__VITE_PUBLIC_ASSET__d363a54c__"